


































import { Prop, VModel, Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import _ from "lodash";
import { format } from "date-fns";
import ProjectService from "@/entities/project/project.service";

@Component
export default class ProjectTextBoxSearch extends Vue {
  items = [];
  loading = false;
  @VModel() selectProjectId;
  search = null;
  placeholder = 'Gõ để tìm kiếm';
  @Prop() label;
  limit = 5;

  @Prop() provinceIdSearch;
  @Prop() rules;
  @Prop() required: boolean;

  searchFn = undefined;

  dateTime(item) {
    return this.formatDateTime(item.createdDate);
  }

  formatDateTime(date) {
    const d = new Date(date);
    return format(d, 'dd/MM/yyyy HH:mm:ss');
  }

  async mounted() {
    const vm = this;
    this.searchFn = _.debounce(async function (newSearchVal) {
      if (vm.selectProjectId) {
        return;
      }
      if (vm.loading) return;
      vm.loading = true;

      let projectService = new ProjectService();
      try {
        let rs = await projectService.search({ page: 0, size: vm.limit }, newSearchVal);
        if (rs && rs.data) {
          vm.items = rs.data || [];
        }
      } finally {
        vm.loading = false;
      }
    }, 500);
    this.searchFn('');
  }

  @Watch('selectProjectId')
  async onSelectProjectIdChange(val, oldVal) {
    if (val) {
      let projectService = new ProjectService();
      let project = await projectService.find(this.selectProjectId);
      this.items = [project];
    }
  }

  @Watch('search')
  async onSearchChange(newSearchVal) {
    this.searchFn(newSearchVal);
  }

  @Watch('provinceIdSearch')
  onProvinceIdSearchChange(val, oldVal) {
    this.searchFn('');
  }
}
